
      import API from "!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/style-loader/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/style-loader/runtime/styleDomAPI.js";
      import insertFn from "!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/style-loader/runtime/insertBySelector.js";
      import setAttributes from "!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/style-loader/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/style-loader/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/style-loader/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/index.js??clonedRuleSet-28.use[1]!builtin:lightningcss-loader??clonedRuleSet-28.use[2]!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/postcss-loader/index.js??clonedRuleSet-28.use[3]!../../node_modules/.pnpm/@rsbuild+plugin-sass@1.3.1_@rsbuild+core@1.3.19/node_modules/@rsbuild/plugin-sass/compiled/resolve-url-loader/index.js??clonedRuleSet-28.use[4]!../../node_modules/.pnpm/@rsbuild+plugin-sass@1.3.1_@rsbuild+core@1.3.19/node_modules/@rsbuild/plugin-sass/compiled/sass-loader/index.js??clonedRuleSet-28.use[5]!./element-variables.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);


if (module.hot) {
  if (!content.locals || module.hot.invalidate) {
    var isEqualLocals = function isEqualLocals(a, b, isNamedExport) {
        if ((!a && b) || (a && !b)) {
          return false;
        }
        var p;
        for (p in a) {
          if (isNamedExport && p === "default") {
            continue;
          }
          if (a[p] !== b[p]) {
            return false;
          }
        }
        for (p in b) {
          if (isNamedExport && p === "default") {
            continue;
          }
          if (!a[p]) {
            return false;
          }
        }
        return true;
      };
    var isNamedExport = !content.locals;
    var oldLocals = isNamedExport ? namedExport : content.locals;

    module.hot.accept(
      "!!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/index.js??clonedRuleSet-28.use[1]!builtin:lightningcss-loader??clonedRuleSet-28.use[2]!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/postcss-loader/index.js??clonedRuleSet-28.use[3]!../../node_modules/.pnpm/@rsbuild+plugin-sass@1.3.1_@rsbuild+core@1.3.19/node_modules/@rsbuild/plugin-sass/compiled/resolve-url-loader/index.js??clonedRuleSet-28.use[4]!../../node_modules/.pnpm/@rsbuild+plugin-sass@1.3.1_@rsbuild+core@1.3.19/node_modules/@rsbuild/plugin-sass/compiled/sass-loader/index.js??clonedRuleSet-28.use[5]!./element-variables.scss",
      function () {
        if (!isEqualLocals(oldLocals, isNamedExport ? namedExport : content.locals, isNamedExport)) {
                module.hot.invalidate();

                return;
              }

              oldLocals = isNamedExport ? namedExport : content.locals;

              update(content);
      }
    )
  }

  module.hot.dispose(function() {
    update();
  });
}


export * from "!!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/index.js??clonedRuleSet-28.use[1]!builtin:lightningcss-loader??clonedRuleSet-28.use[2]!../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/postcss-loader/index.js??clonedRuleSet-28.use[3]!../../node_modules/.pnpm/@rsbuild+plugin-sass@1.3.1_@rsbuild+core@1.3.19/node_modules/@rsbuild/plugin-sass/compiled/resolve-url-loader/index.js??clonedRuleSet-28.use[4]!../../node_modules/.pnpm/@rsbuild+plugin-sass@1.3.1_@rsbuild+core@1.3.19/node_modules/@rsbuild/plugin-sass/compiled/sass-loader/index.js??clonedRuleSet-28.use[5]!./element-variables.scss";
       export default content && content.locals ? content.locals : undefined;
